<div class="banner">
    <div class="data-container">
        <h2 class="thin-font">SINIRJI 911 PUBLIC ACCESS</h2>
        <h2 class="semibold-font">REAL TIME ACTIVITY</h2>
        <h2 class="semibold-font">FROM 911 CALL CENTERS</h2>
    </div>
</div>
<div class="map-title">
    <h2 style="font-size: 30px">Real-Time Web-based Access to Critical Incident Info</h2>
</div>
<div *ngIf="db_read_complete" class="map">
    <div class="map-container">
        <app-map [events]="events" [params]="map_params"></app-map>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/components/home/home.component.html